import React, { Component } from "react";
import _ from "lodash";
import LocaleStrings from "Languages";
import { connect } from "react-redux";
import { BASE_IMAGES_URL } from "Constants";
import NoDataFoundTrow from "NoDataFoundTrow";

class TableContentTopCountriesExhibitors extends Component {
  // Create table body
  renderExhibitorinsightTopCountriesTablelist() {
    var items = _.map(
      this.props.exhibitorsinsightTopcountriesTablelist,
      (values) => {
        var imagePath = "";

        var imagePath = `${BASE_IMAGES_URL}/${values.profilethumbimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
        return (
          <tr key={values.name}>
            <td>
              <div className="row">
                <div className="col-md-12 col-lg-12 d-flex">
                  <div className="analytics-table-td">
                    {" "}
                    {values.country
                      ? values.country
                      : LocaleStrings.analytics_unknown}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <div align="left">
                    <img
                      className="rounded-circle analytics-table-cust-img"
                      alt={values.speakername}
                      src={imagePath}
                    />{" "}
                    {values.name.length > 80
                      ? values.name.substring(0, 80) + "..."
                      : values.name}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        );
      }
    );

    return items;
  }
  // Printing the output
  render() {
    let { exhibitorsinsightTopcountriesTablelist } = this.props;
    return (
      <div className="social-content">
        <div className="tableHeaderSection">
          <p className="analytics-chart-header">
            {LocaleStrings.analytics_exhibitorsinsights_table_header_text1}
          </p>
          <p className="analytics-chart-subheader">
            {LocaleStrings.analytics_exhibitorsinsights_table_subheader_text1}
          </p>
        </div>
        <table className="table">
          <thead className="analyticsTable">
            <tr>
              <th>{LocaleStrings.analytics_country}</th>
              <th>{LocaleStrings.analytics_exhibitor}</th>
            </tr>
          </thead>
          <tbody className="tbody-background">
            {exhibitorsinsightTopcountriesTablelist.length > 0 ? (
              this.renderExhibitorinsightTopCountriesTablelist()
            ) : (
              <NoDataFoundTrow
                colspan="2"
                classes="text-center"
                text={LocaleStrings.no_data_found}
              />
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    exhibitorsinsightTopcountriesTablelist:
      typeof state.exhibitorsinsightTopcountriesTablelist === Object ? [] : [],
  };
}

export default connect(mapStateToProps)(TableContentTopCountriesExhibitors);
